import React, { useRef } from 'react';
import _ from 'lodash';
import { FaFacebookF, FaLinkedinIn, FaYoutube, FaInstagram } from 'react-icons/fa';
import { FooterLinksContainer, FooterLinks, FooterBar, LinkListSpan } from './styles/Footer.styled';
import { FooterBottom } from './styles/FooterBottom.styled';
import { Subscription } from './styles/Subscription.styled';
import { Button } from './styles/Button.styled';
import { Link } from './styles/Link.styled';
import { FooterLinkBlocks } from './styles/FooterLinkBlocks.styled';
import { LinkBlock } from './styles/LinkBlock.styled';
import { LinkList } from './styles/LinkList.styled';
import { CTAWrapper } from './styles/CTAWrapper.styled';
import { SocialLinks, SocialLinkFooter } from './styles/SocialLinks.styled';
import ChatwithusIcon from '../assets/svg/chatwithus.svg';
import { DWTCContext } from '../utils/context';
import LiveChat from './LiveChat';
import Sprites from './Sprites';

export default function Footer({ settings, dir }) {
  const chatRef = useRef(null);
  const { cssClass } = React.useContext(DWTCContext);
  const getTheme = () => {
    if (_.includes(cssClass, 'free-zone')) return 'red';
    if (_.includes(cssClass, 'real-estate')) return 'green';
    return 'secondary';
  };
  
  const openChat = () => {
    chatRef.current.toggleVisibility();
  };

  const region = dir === 'rtl' ? 'ar' : 'en';

  return (
    <FooterBar dir={dir}>
      <FooterLinksContainer className="content" dir={dir}>
        <FooterLinks className="linking" dir={dir}>
          <FooterLinkBlocks>
            {settings.footerMenu.map((item, index) => (
              <LinkBlock dir={dir} role="menu" key={index} className="footer_ullink">
                <LinkList dir={dir} key={index}>
                  {item.content.urls.map((link, index1) =>
                    index1 === 0 ? (
                      <LinkListSpan role="menuitem" key={index1} dir={dir}>
                        <strong>
                          <Link 
                          target={link.target}
                          to={link.url}>{link.name}</Link>
                        </strong>
                      </LinkListSpan>
                    ) : (
                      <LinkListSpan role="menuitem" key={index1} dir={dir}>
                        <Link
                          target={link.target}
                          to={
                            cssClass?.includes('free-zone') && link.url?.includes('faqs')
                              ? `/${region}/free-zone/support-centre/free-zone-faqs/`
                              : link.url
                          }>
                          {link.name}
                        </Link>
                      </LinkListSpan>
                    ),
                  )}
                </LinkList>
              </LinkBlock>
            ))}
            <CTAWrapper className="footer_cta_wrapper" dir={dir}>
              {settings.callUsLink && settings.callUsLink.url && (
                <Button
                  href="tel:8003982"
                  dir={dir}
                  data-tel="8003982"
                  stylevariant="outline"
                  className="cta_btn_cc ltr:!font-URWDINBold pt-[12px]">
                  {settings.callUsLink.name}&nbsp;
                  <span className="has-phone">800 DWTC (3982)</span>
                </Button>
              )}
              {settings.chatWithUsLink && (
                <Button
                  onClick={openChat}
                  to="#0"
                  dir={dir}
                  stylevariant="outline"
                  className="chatwithus cta_btn_cc ltr:!font-URWDINBold pt-[12px]">
                  <ChatwithusIcon /> <span>{settings.chatWithUsLink.name}</span>
                </Button>
              )}
              <SocialLinks className="footer_link flex flex-col md:flex-row gap-y-3" dir={dir}>
                <p className="social-title !text-[12px] md:!text-[10px]" dir={dir}>
                  {settings.connectWithUsLabel}
                </p>

                <div className="flex">
                  {_.includes(cssClass, 'free-zone') ? (
                    <>
                      <SocialLinkFooter
                        className="social_link"
                        href="https://www.facebook.com/profile.php?id=61567230710769"
                        rel="noreferrer nofollow"
                        target="_blank"
                        dir={dir}>
                        <span className="sr-only">Facebook</span>
                        <FaFacebookF
                          size={23}
                          fill="#fff"
                          title="Facebook"
                          className="facebook social_icons"
                        />
                      </SocialLinkFooter>
                      <SocialLinkFooter
                        className="social_link"
                        href="https://www.linkedin.com/company/dwtc-freezone/"
                        rel="noreferrer nofollow"
                        target="_blank"
                        dir={dir}>
                        <span className="sr-only">LinkedIn</span>
                        <FaLinkedinIn
                          size={23}
                          fill="#fff"
                          title="LinkedIn"
                          className="linkedin social_icons"
                        />
                      </SocialLinkFooter>
                      <SocialLinkFooter
                        className="social_link"
                        href="https://www.instagram.com/dwtc_freezone/"
                        rel="noreferrer nofollow"
                        target="_blank"
                        dir={dir}>
                        <span className="sr-only">Instagram</span>
                        <FaInstagram
                          size={23}
                          fill="#fff"
                          title="instagram"
                          className="instagram social_icons"
                        />
                      </SocialLinkFooter>
                    </>
                  ) : (
                    <>
                      <SocialLinkFooter
                        className="social_link"
                        href="https://www.facebook.com/DubaiWorldTradeCentre"
                        rel="noreferrer nofollow"
                        target="_blank"
                        dir={dir}>
                        <span className="sr-only">Facebook</span>
                        <FaFacebookF
                          size={23}
                          fill="#fff"
                          title="Facebook"
                          className="facebook social_icons"
                        />
                      </SocialLinkFooter>
                      <SocialLinkFooter
                        className="social_link"
                        href="https://www.linkedin.com/company/dubai-world-trade-centre"
                        rel="noreferrer nofollow"
                        target="_blank"
                        dir={dir}>
                        <span className="sr-only">LinkedIn</span>
                        <FaLinkedinIn
                          size={23}
                          fill="#fff"
                          title="LinkedIn"
                          className="linkedin social_icons"
                        />
                      </SocialLinkFooter>
                      <SocialLinkFooter
                        className="social_link twitter_footer_x"
                        href="https://twitter.com/DWTCOfficial"
                        rel="noreferrer nofollow"
                        target="_blank"
                        dir={dir}>
                        <Sprites name="twitter-x" />
                      </SocialLinkFooter>
                      <SocialLinkFooter
                        className="social_link"
                        href="https://www.youtube.com/channel/UCccIuRcgWzXAgNsZ7zkO5mA"
                        rel="noreferrer nofollow"
                        target="_blank"
                        dir={dir}>
                        <span className="sr-only">YouTube</span>
                        <FaYoutube
                          size={23}
                          fill="#fff"
                          title="YouTube"
                          className="youtube social_icons"
                        />
                      </SocialLinkFooter>
                      <SocialLinkFooter
                        className="social_link"
                        href="https://www.instagram.com/dubaiworldtradecentre/"
                        rel="noreferrer nofollow"
                        target="_blank"
                        dir={dir}>
                        <span className="sr-only">Instagram</span>
                        <FaInstagram
                          size={23}
                          fill="#fff"
                          title="instagram"
                          className="instagram social_icons"
                        />
                      </SocialLinkFooter>
                    </>
                  )}
                </div>
              </SocialLinks>
            </CTAWrapper>
          </FooterLinkBlocks>
          <FooterBottom dir={dir}>
            {settings.bottomLinks &&
              settings.bottomLinks.map((link, index) => (
                <Link
                  key={index}
                  to={link.url}
                  target={link.target}
                  title={link.name}
                  className="ltr:text-[9px] ltr:sm:!text-[8px] ltr:md:!text-[7px] rtl:!text-[11px] rtl:md:!text-[10px]">
                  {link.name}
                </Link>
              ))}
            <p className="copy ltr:text-[9px] ltr:sm:!text-[8px] ltr:md:!text-[7px] rtl:!text-[11px] rtl:md:!text-[10px]">
              {settings.copyrightText.replace('{{YEAR}}', new Date().getFullYear())}
            </p>
          </FooterBottom>
        </FooterLinks>
      </FooterLinksContainer>

      <Subscription
        color={getTheme()}
        className={`${getTheme() === 'red' ? 'hidden md:block' : ''} subscribe`}
        dir={dir}>
        <div className="sub-content">
          <h2 className="ltr:!font-LibreBaskervilleRegular">{settings.subscribeTitle}</h2>
          <p className="sub2" dir={dir}>
            {settings.subscribeText}
          </p>
          <div className="cta">
            {settings.subscribeLink && (
              <Button
                to={settings.subscribeLink.url}
                dir={dir}
                color={getTheme()}
                className="footer_subscribebutton">
                {settings.subscribeLink.name}
              </Button>
            )}
          </div>
        </div>
      </Subscription>
      <LiveChat ref={chatRef} />
    </FooterBar>
  );
}
